export const DEFAULT_TIMEZONE = 'Europe/Amsterdam';